import { deepMerge, deepDestringifyFunctions, deepClone } from 'smbls'

import * as platformMethods from './index.js'

export function prepareFrameProps(scope, state) {
  const { frameProps } = scope

  return deepMerge(
    {
      ':focus-within': { outline: 'none' },
      ...frameProps,
      ...state.props
    },
    {
      zoom: this.getUserSettings('zoomLevel'),
      direction: this.getUserSettings('languageDirection')
    }
  )
}

export function prepareCode(code) {
  const clonedCode = deepClone(code)
  try {
    return deepDestringifyFunctions(clonedCode)
  } catch (e) {
    console.error(e)
    return deepClone(clonedCode)
  }
}

export function prepareRouter(data, scope) {
  return scope.router || scope.useRouter
    ? // handle direct routing
      (path) =>
        this.call(
          'router',
          scope.activeItem || path || '',
          this,
          {},
          {
            window: window.top || window
          }
        )
    : // handle canvas routing
      function (path, ...params) {
        if (
          typeof path !== 'string' ||
          !path.startsWith('/') ||
          !(
            this.getRootState() &&
            this.getUserSettings('allowCanvasReplaceRouter')
          ) ||
          params[2]?.initialRender
        )
          return
        window.setTimeout(() => {
          const chosen = this.getChosenKey()
          const key = '/' + path.split('/')[1]
          this.activateSelected(key)
          if (!chosen) {
            this.zoomToNode(this.getSelected())
          }
        }, 1)
      }
}

export function prepareUtils(data, scope) {
  const router = this.prepareRouter?.(data, scope)
  return {
    ...data?.functions,
    ...data?.snippets,
    router
  }
}

export function prepareMethods(data, scope) {
  const router = this.prepareRouter?.(data, scope)
  return {
    ...platformMethods,
    ...data?.methods,
    router
  }
}

export function prepareInitOptions(scope, emotion) {
  return {
    ...scope.initOptions,
    newConfig: {},
    emotion
  }
}
